<template>
	<div id="app">
		<keep-alive>
			<router-view class="routerContent" v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<!-- 没有缓存 -->
		<router-view class="routerContent" v-if="!$route.meta.keepAlive"></router-view>
	</div>
</template>

<script>
import { Toast } from "vant";
import useApi from '@/api/auth'
export default {
	name: 'App',
	created(){
    if(window.localStorage.userinfo){
      if(JSON.parse(window.localStorage.userinfo).id){
        if(!window.localStorage.personalInformation||window.localStorage.personalInformation=='undefined'){ // 有id没有用户信息调接口
          var params = {
            regionId:"",
            id:""
          }
          useApi.obtainUseInfor(params).then(res => {
            // Toast(JSON.stringify(res.data));
            if(res.success){
              window.localStorage.personalInformation = JSON.stringify(res.data); // 用户基本信息
            }
          })
        }
      }else{
        window.localStorage.personalInformation = JSON.stringify(undefined);
      }
    }else{
      window.localStorage.personalInformation = JSON.stringify(undefined);
    }
	},
	mounted() {},
	methods:{
	}
}
</script>

<style>
	/* @font-face {
		font-family:"微软雅宋"; 
		src: url("./assets/ttf/FZBIAOYSJW.TTF");
	} */
	*{
		margin: 0;
		padding: 0;
	}
	a {
		color: #424242
	}
	li {
		list-style: none;
	}

	input:-webkit-autofill {
		-webkit-box-shadow: 0 0 0 1000px white inset;
	}

	html {
		-webkit-overflow-scrolling: touch;
	}
	/* html {
		height: 100%;
	} */
	body {
		/* max-width: 700px; */
		overflow-x: hidden;
		background: #f1f1f1;
		/* margin: 0 auto!important; */
	}
	body,html{
		width: 100%;
		height: 100%;
	}
	#app {
		font-family: "微软雅宋";
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-size: 14px;
		width: 100%;
		height: 100%;
		color: #333333;
		background: #fff;
		margin: 0px auto;
		/* max-width: 700px; */
	}
	.routerContent {
		width: 100%;
		height: 100%;
		overflow-y: auto;
		overflow-x: hidden;
		/* padding-bottom: 50px; */
		box-sizing: border-box;
	}
</style>
